import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-move-asset-popover',
  templateUrl: './move-asset-popover.component.html',
  styleUrls: ['./move-asset-popover.component.scss'],
})
export class MoveAssetPopoverComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
